import { privateApi, publicApi } from 'services';
import { CurrentUserFromApi, PresentationMode, VerifyTrialAccountCreation } from './types';
import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';

export const USER_NOT_FOUND_API_ERROR_MESSAGE = 'User not found in database';

const createUserFromToken = async (): Promise<void> => privateApi.post<void>('users/create-from-token');

const changePresentationMode = (userId: string, presentationMode: PresentationMode): Promise<PresentationMode> =>
    privateApi.put<PresentationMode>(`users/${userId}/presentation-mode`, presentationMode);

const fetchCurrentUser = async (): Promise<CurrentUserFromApi> => privateApi.get<CurrentUserFromApi>('users/me');

const fetchCurrentUserVerifyTrialAccountCreation = async (token: string): Promise<VerifyTrialAccountCreation> =>
    publicApi.get<VerifyTrialAccountCreation>('public/verify-trial-account-creation', {
        headers: { Authorization: `Bearer ${token}` },
    });

export const CurrentUserGateway = {
    createUserFromToken,
    changePresentationMode,
    fetchCurrentUser,
    fetchCurrentUserVerifyTrialAccountCreation,
};

const cancelableFetchCurrentUser = async (): Promise<CurrentUserFromApi> =>
    privateApiWithRouteLeavingCancelation.get<CurrentUserFromApi>('users/me');

export const CancelableCurrentUserGateway = {
    cancelableFetchCurrentUser,
};
